var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldType } from "@ngx-formly/core";
import { ToasterService } from "angular2-toaster";
import { JobOffersService } from "app/services";
import { DP_FORMAT, MAX_EXP_GG } from "app/views/jobOffers/edit-join-offer/exports";
import * as moment from "moment";
var FormlyFieldUpdateExpiryDate = /** @class */ (function (_super) {
    __extends(FormlyFieldUpdateExpiryDate, _super);
    function FormlyFieldUpdateExpiryDate(jos, toaster) {
        var _this = _super.call(this) || this;
        _this.jos = jos;
        _this.toaster = toaster;
        _this.form = new FormGroup({});
        _this.model = {
            showErrorState: true,
            isLoading: false,
        };
        _this.fields = [];
        return _this;
    }
    FormlyFieldUpdateExpiryDate.prototype.onSubmit = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            var expiration_date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // this.isLoading = true;
                        this.model.isLoading = true;
                        expiration_date = model.expiration_date;
                        return [4 /*yield*/, this.jos.updateExpirationDate(this.field.templateOptions.id, expiration_date).toPromise()];
                    case 1:
                        _a.sent();
                        this.model.isLoading = false;
                        this.toaster.pop('success', "Job Updated successfully.");
                        return [2 /*return*/];
                }
            });
        });
    };
    FormlyFieldUpdateExpiryDate.prototype.ngOnInit = function () {
        this.fields = [
            {
                key: "expiration_date",
                type: "date",
                defaultValue: this.field.templateOptions.expDate || moment().add(1, 'days').format(DP_FORMAT),
                // moment('2022-01-01').format(DP_FORMAT) || expDate,
                validation: {
                    show: true,
                },
                expressionProperties: {
                    'validation.show': 'model.showErrorState',
                },
                templateOptions: {
                    label: "Expiration Date",
                    /* eslint-disable */
                    /* @ts-ignore */
                    _min: moment().add(1, 'days').format(DP_FORMAT),
                    /* @ts-ignore */
                    _max: moment().add(MAX_EXP_GG, 'days').format(DP_FORMAT),
                    /* eslint-enable */
                    required: true,
                    config: {
                        format: DP_FORMAT,
                    },
                },
                validators: {
                    ip: {
                        expression: function (c) {
                            return moment(c.value).isSameOrAfter(moment().add(1, 'days').format(DP_FORMAT));
                        },
                        message: function (error, field) { return field.formControl.value + " must be grater then today"; },
                    },
                },
            },
            {
                key: "submit",
                type: "submit",
                templateOptions: {
                    buttonLabel: "Save",
                    form: this.form,
                    className: "btn btn-success btn-block",
                },
                expressionProperties: {
                    'templateOptions.disabled': 'model.isLoading',
                },
            },
        ];
    };
    return FormlyFieldUpdateExpiryDate;
}(FieldType));
export { FormlyFieldUpdateExpiryDate };
